import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-stepper-page-ui',
    templateUrl: './bb-stepper-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbStepperPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
